import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpHeaders,
  HttpParams,
} from "@angular/common/http";
import { environment } from "../../../environments/environment";
import "rxjs/add/operator/map";
import { Observable } from "rxjs";
import { CreateProductPoints, IProductPoints, UpdateProductPoints } from "../../master-models/productPoints.model";

@Injectable()
export class ProductPointsCatalogService {
  url = `${environment.apiBaseUrl}api/product_points_catalog`;

  constructor(private http: HttpClient) {}

  getProductsList(inStock: boolean): Observable<{success: boolean, data: IProductPoints[]}> {
    const params: any = {};
    if (inStock) {
      params.in_stock = 'true';
    }
    return this.http.get<{success: boolean, data: IProductPoints[]}>(this.url, {
      headers: this.getHeaders(),
      params
    });
  }

  createProduct(createProduct: FormData): Observable<{success: boolean, product: IProductPoints}> {
    return this.http.post<{success: boolean, product: IProductPoints}>(this.url, createProduct, {
      headers: this.getHeaders()
    });
  }

  updateProduct(id: number, updateProduct: UpdateProductPoints | FormData): Observable<{success: boolean; message: string}> {
    const url = `${this.url}/${id}`;

    if (updateProduct instanceof FormData) {
      return this.http.post<{success: boolean; message: string}>(url, updateProduct, {
        headers: this.getHeaders()
      });
    }

    return this.http.patch<{success: boolean; message: string}>(url, updateProduct, {
      headers: this.getHeaders()
    });
  }

  getHeaders(): HttpHeaders {
    const token = localStorage.getItem("token_user");
    return new HttpHeaders({
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/master-services/productPointsCatalog/product-points-catalog.service.ts